<template>
	<div class="tab" @mouseover="mouseover" @mouseleave="mouseleave" style="position: relative">
		<article class="media">
			<div class="media-left">
				<a :href="body.url" target=”_blank”>
				<img 
					v-show="is_show_thumbnail"
					:src="thumbnail_src"
					style="width:100px;height:100px"
				>
				<div
					v-show="!is_show_thumbnail"
					style="width:100px;height:100px;background:#f6f6f6"
				>
				</div>
				</a>
			</div>
			<div class="media-content wrap between" style="min-height:100px;overflow: hidden;padding-top: 10px;">
				<div class="line-2">
					<a :href="body.url" target="_blank" class="title">{{ body.title }}</a>
					<br>
					<small>{{ hostname }}</small>
				</div>
				<div v-show="TabFilterBtn_show" class="tab_filter_button">
					<TabFilterBtn :body="body" />
				</div>
				<div>
					<div class="tags tags_position">
						<span
							class="button tag"
							v-for="(tag, index) in tags"
							:key="index"
							:class='{"selected-tag": is_selected_tag(tag.tag_id)}'
							@click="click_tag(tag)"
						>
							{{ tag.name }}
						</span>
					</div>
				</div>
				<small　class="created_at">{{ created_at }}</small>
			</div>
		</article>
	</div>
</template>
<script>
import TabFilterBtn from './TabFilterBtn.vue'
export default {
	name: 'Tab',
	data() {
		return {
			TabFilterBtn_show: false
		}
	},
	props: {
		body: {
			type: Object,
			required: true
		},
	},
	computed: {
		is_show_thumbnail() {
			if (this.body.thumbnail_src && this.body.thumbnail_src != '') {
				return true
			}
			if (this.body.og_image && this.body.og_image != '') {
				return true
			}
			if (this.body.thumbnail_base64 && this.body.thumbnail_base64 != '') {
				return true
			}
			return false
		},
		thumbnail_src() {
			if (this.body.thumbnail_src && this.body.thumbnail_src != '') {
				return this.body.thumbnail_src
			}
			if (this.body.og_image && this.body.og_image != '') {
				return this.body.og_image
			}
			if (this.body.thumbnail_base64 && this.body.thumbnail_base64 != '') {
				return this.body.thumbnail_base64
			}
			return ""
		},
		tags() {
			return this.body.tags
				.filter(tag => {
					return (tag.status == 'auto-attach' || tag.status == 'manual-attach')
				})
				.sort((a, b) => {
					return (a.tag_id == this.selected_tag) ? -1 : 1
				})
		},
		hostname: function() {
			var result = this.body.url.replace(/\\/g, '/').match(/\/\/([^/]*)/);
			if (!result) return '';
			return result[1];
		},
		selected_tag: function() {
			return this.$store.getters['tags/selected']
		},
		created_at: function() {
			const tmp = new Date(this.body.updatedAt)
			const month = tmp.getMonth() + 1
			const day = tmp.getDate()
			const hour = tmp.getHours() < 10 ? `0${tmp.getHours()}` : tmp.getHours()
			const min = tmp.getMinutes() < 10 ? `0${tmp.getMinutes()}` : tmp.getMinutes()
			return `${month}/${day} ${hour}:${min}`
		},
	},
	methods: {
		mouseover: function() {
			this.TabFilterBtn_show = true
		},
		mouseleave: function() {
			this.TabFilterBtn_show = false
		},
		is_selected_tag: function (tag_id) {
			return (tag_id === this.selected_tag)
		},
		click_tag(tag) {
			this.$store.dispatch('tags/set_selected', tag.tag_id)
		}
	},
	components: {
		TabFilterBtn,
	}
}
</script>
<style scoped>
.tab {
	border: 1px solid lightgray;
	/* border-top: 0px; */
	border-bottom: 0px;
	/* padding: 10px 10px; */
	/* padding-bottom: 0px; */

	text-align: left;
	background-color: white;
}
.title {
	font-size: 1em;
	color: rgba(0, 0, 0, 0.87) !important;
}
.line-2 {
  overflow: hidden;
  height: 2.6em; /* 2em（行）x line-heightの1.8 */
  line-height: 1.3em;
}
img {
	object-fit: cover;
}
.description {
	margin-bottom: 0px;
}
.tab_filter_button {
	position:absolute;
	right: 1px;
	top: 1px;
	background: white;
	padding: 5px 0px;
	padding-left: 10px;
}

.wrap {
	display:-webkit-box;
	display:-ms-flexbox;
	display:flex;
	flex-flow: column;
	min-height:100px;
}
.between {
	-webkit-box-pack:justify;
	-ms-flex-pack:justify;
	justify-content:space-between;
}

.selected-tag {
	background: #6EBD91 !important;
	color: #fff;
	font-weight: bold;
}

.created_at {
	position:absolute;
	right: 10px;
	bottom: 1px;
	background: white;
	padding: 5px 0px;
	padding-left: 10px;	
}

.tags_position {
	position:absolute;
	left: 115px;
	bottom: 10px;
}
</style>
